"use client";

import { Box, Button, Container, Paper, Typography } from "@mui/material";
import { useRouter } from "next/navigation";

export default function ConfirmationMessageInvite() {
  return (
    <Box
      sx={{
        p: 3,
        bgcolor: "white",
        borderRadius: 2,
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        flex: 1,
      }}
    >
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Paper
          sx={{
            p: 4,
            bgcolor: "#f8fbff",
            textAlign: "center",
            maxWidth: 800,
            mx: "auto",
          }}
        >
          <Box sx={{ mb: 4 }}>
            <Typography
              sx={{
                color: "#555",
                mb: 2,
                lineHeight: 1.6,
              }}
            >
              Thank you for sending email to your parent to register an account
              on Pythaverse.
            </Typography>
            <Typography
              sx={{
                color: "#555",
                mb: 2,
                lineHeight: 1.6,
              }}
            >
              We&apos;ve just send an email to this email address to invite for
              creating account.
            </Typography>
            <Typography
              sx={{
                color: "#555",
                mb: 2,
                lineHeight: 1.6,
              }}
            >
              Please inform your parent to check his/her email address to finish
              the account registration process. When your parent has
              successfully created an account on Pythaverse, you can see his/her
              account connected to your account. Thank you!
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
